import { AUTH_ENDPOINT_BASE_URL, AUTH_ENDPOINT_BASE_URL_PARAMS } from './config'

export const environment = {
  production: true,
  authenticated: false,
  hmr: false,
  authUrl: `${AUTH_ENDPOINT_BASE_URL}/go_af9c2864fb0c77399462fa8c207a0e04Wr4VtgZG05R?
  ${AUTH_ENDPOINT_BASE_URL_PARAMS}`,
}
